import { classNames } from "../../helpers/classNames";

/**
 * Empty and error states share one shape (docs/design/HANDOFF.md): icon in a
 * circle, a serif heading, one sentence, one action.
 *
 * `tone` "rose" for empty states, "red" for errors (see `ErrorState`).
 */
const TONES = {
  rose: "bg-md-pink/10 text-md-pink-dark",
  red: "bg-red-50 text-red-700",
};

const EmptyState = ({ icon = null, tone = "rose", title, children, action = null, className }) => (
  <div
    className={classNames(
      "flex flex-col items-center gap-3 rounded-[18px] border border-md-pink-light-1 bg-white px-5 py-9 text-center md:py-10",
      className
    )}
  >
    {icon ? (
      <span aria-hidden="true" className={classNames("flex h-16 w-16 items-center justify-center rounded-full", TONES[tone] || TONES.rose)}>
        {icon}
      </span>
    ) : null}
    <h2 className="m-0 font-heading text-2xl font-normal leading-tight text-md-dark">{title}</h2>
    {children ? <p className="m-0 max-w-sm text-[15px] leading-snug text-md-muted md:text-base">{children}</p> : null}
    {action ? <div className="mt-1.5">{action}</div> : null}
  </div>
);

export default EmptyState;
